import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import PageActionBar from 'components/PageActionBar';
import UserFilters from 'components/Filters/UserFilters';
import EmployeeList from './employeeList';
import EmployeeDetails from './employeeDetails';
import EmployeeNew from './employeeNew';
import EmployeeEdit from './employeeEdit';
import { navigate, requestWorkroomList, setEmployeeFilters, resetEmployeeFilters } from 'actionCreators';
import { getRole, getEmployeeFilters } from '../../../../reducers';
import ui from 'redux-ui';
import { can } from '../../../../services';
import contentAreaStyles from 'styles/contentArea';

class Employees extends React.Component {
  constructor(context, props) {
    super(context, props);
    this.addAction = this.addAction.bind(this);
    this.toggleFilterDrawer = () =>
      this.setState({ showFilterDrawer: !this.state.showFilterDrawer });
    this.handleFilterChange = filters => this.props.setEmployeeFilters(filters);
    this.state = {
      showFilterDrawer: false, canViewInactive: can(this.props.role, 'view', 'inactive'),
    };
    this.isIndexRoute = () => this.props.location.pathname === this.props.route.path;
  }

  componentDidMount = () => this.props.requestWorkroomList();

  onSearch = (e, value) => {
    e.preventDefault();
    const filters = { ...this.props.filters };
    filters.query = value;
    this.handleFilterChange(filters);
  }

  addAction = () => this.props.navigate('/employees/new')

  render = () => <div>
    <PageActionBar
      resource="employee"
      role={this.props.role}
      addAction={this.addAction}
      showFiltersBtn={this.isIndexRoute()}
      title="Employee Management"
      searchText="Search for an employee by name or position"
      toggleFilters={this.toggleFilterDrawer}
      onSearch={this.onSearch}
      path={this.props.location.pathname}
    />
    <div className={contentAreaStyles.contentAreaContainer}>
      {this.props.children}
      <UserFilters
        active={this.state.showFilterDrawer}
        onOverlayClick={this.toggleFilterDrawer}
        handleFilterChange={this.handleFilterChange}
        filters={this.props.filters}
        title="Employees"
        reset={this.props.resetEmployeeFilters}
        showRoles
        role={this.props.role}
        resource="employee"
      />
    </div>
  </div>
}

Employees.propTypes = {
  setEmployeeFilters: PropTypes.func.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  route: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }).isRequired,
  role: PropTypes.string,
  requestWorkroomList: PropTypes.func.isRequired,
  navigate: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  resetEmployeeFilters: PropTypes.func.isRequired,
  filters: PropTypes.object,
};

const mapStateToProps = state => ({
  role: getRole(state), filters: getEmployeeFilters(state),
});

export default ui({ key: 'employees', state: { successMessage: '', activeTab: 0 } })(connect(
  mapStateToProps, { requestWorkroomList, navigate, setEmployeeFilters, resetEmployeeFilters },
)(Employees));

export { EmployeeList, EmployeeDetails, EmployeeNew, EmployeeEdit };



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/employees/index.jsx